import * as bootstrap from "bootstrap";

class ConfirmationModalService {
  reset(element) {
    this.modalTarget = element;

    this.titleTarget = this.modalTarget.querySelector(".modal-title");
    this.bodyTarget = this.modalTarget.querySelector(".modal-body p");
    this.modal = new bootstrap.Modal(this.modalTarget);

    this.modalTarget.querySelector(".confirm").addEventListener("click", () => {
      this.modal.hide();
      this.deferred.resolve();
    });

    this.modalTarget.addEventListener("hidden.bs.modal", () => {
      this.deferred.reject();
    });
  }

  show(body, title = "Confirmation") {
    this.titleTarget.textContent = title;
    this.bodyTarget.textContent = body;

    this.modal.show();

    this.deferred = $.Deferred();

    return this.deferred.promise();
  }
}

export default window.ConfirmationModalService = new ConfirmationModalService();
